export class SearchResultBuilder {
    constructor() {
        this.search = {};
    }

    setId(id) {
        this.search.id = id;
        return this;
    }

    setMessage(message) {
        this.search.message = message;
        return this;
    }

    setDate(date) {
        this.search.date = date;
        return this;
    }

    setParam(param){
        this.search.param = param;
        return this;
    }

    build() {
        return this.search;
    }
}
